import { render, staticRenderFns } from "./Login_JianKang.vue?vue&type=template&id=0f55b5b0&scoped=true"
import script from "./Login_JianKang.vue?vue&type=script&lang=js"
export * from "./Login_JianKang.vue?vue&type=script&lang=js"
import style0 from "./Login_JianKang.vue?vue&type=style&index=0&id=0f55b5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55b5b0",
  null
  
)

export default component.exports